var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageRecipients = function SvgMessageRecipients(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-4);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 31,
    y1: 195.8,
    x2: 209.6,
    y2: 79.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 25.5,
    y1: 187.3,
    x2: 204.1,
    y2: 71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -11.7,
    y1: 130.2,
    x2: 166.9,
    y2: 13.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -23.7,
    y1: 111.8,
    x2: 154.9,
    y2: -4.5,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.4,138.1c8.8-5.5,14.6-15.2,14.6-26.3h0c0-17.1-13.9-31-31-31s-31,13.9-31,31,5.8,20.8,14.6,26.3c-16.5,6.5-28.2,22.6-28.2,41.4v16.3c0,2.2,1.7,3.9,3.9,3.9h81.3c2.2,0,3.9-1.7,3.9-3.9v-16.3c0-18.8-11.7-34.9-28.2-41.4ZM76.8,111.8c0-12.8,10.4-23.2,23.2-23.2,12.8,0,23.2,10.4,23.2,23.2,0,12.8-10.4,23.2-23.2,23.2,0,0,0,0,0,0s0,0,0,0c-12.8,0-23.2-10.4-23.2-23.2ZM136.7,191.9H63.3v-12.4c0-20.3,16.4-36.7,36.7-36.7,20.3,0,36.7,16.4,36.7,36.7v12.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M194.3,109.5c-5.2-9.3-13.3-15.9-22.4-19.6,8.8-5.5,14.6-15.2,14.6-26.3h0c0-17.1-13.9-31-31-31-17.1,0-31,13.9-31,31,0,11.1,5.8,20.8,14.6,26.3-1.9.7-3.7,1.6-5.5,2.6-1.9,1.1-2.5,3.4-1.5,5.3,1.1,1.9,3.4,2.6,5.3,1.5,5.5-3.1,11.7-4.7,18-4.7,20.3,0,36.8,16.4,36.8,36.7v12.4h-49.4c-2.2,0-3.9,1.7-3.9,3.9s1.7,3.9,3.9,3.9h53.3c2.2,0,3.9-1.7,3.9-3.9v-16.3c0-7.7-2-15.2-5.7-21.9ZM132.3,63.6c0-12.8,10.4-23.2,23.2-23.2,12.8,0,23.2,10.4,23.2,23.2h0c0,12.7-10.3,23.1-23,23.2-.1,0-.3,0-.4,0-12.7,0-23-10.4-23-23.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M61.1,147.6c0-2.2-1.7-3.9-3.9-3.9H7.8v-12.4c0-6.3,1.6-12.5,4.7-18,6.7-11.9,19.1-18.6,31.8-18.7,0,0,.1,0,.2,0,0,0,0,0,.1,0,6.1,0,12.2,1.5,17.9,4.7,1.9,1.1,4.3.4,5.3-1.5,1.1-1.9.4-4.3-1.5-5.3-1.8-1-3.6-1.9-5.5-2.6,8.8-5.5,14.6-15.2,14.6-26.3,0-17.1-13.9-31-31-31s-31,13.9-31,31c0,11.1,5.8,20.8,14.6,26.3C11.7,96.5,0,112.6,0,131.4v16.3c0,2.2,1.7,3.9,3.9,3.9h53.3c2.2,0,3.9-1.7,3.9-3.9ZM21.4,63.6c0-12.8,10.4-23.2,23.2-23.2,12.8,0,23.2,10.4,23.2,23.2,0,12.8-10.4,23.2-23.2,23.2s-23.2-10.4-23.2-23.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100,62.3c17.1,0,31-13.9,31-31,0-17.1-13.9-31-31-31s-31,13.9-31,31,13.9,31,31,31ZM100,8.1c12.8,0,23.2,10.4,23.2,23.2,0,12.8-10.4,23.2-23.2,23.2s-23.2-10.4-23.2-23.2,10.4-23.2,23.2-23.2Z"
  })));
};
export default SvgMessageRecipients;